import { render, staticRenderFns } from "./BlogSearchMod.vue?vue&type=template&id=52a7a34f"
import script from "./BlogSearchMod.vue?vue&type=script&lang=js"
export * from "./BlogSearchMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports